import React from 'react';
import { getContext } from '@fiverr-private/fiverr_context';
import { Image } from '@fiverr-private/media';
import { Container } from '@fiverr-private/layout_components';
import {
    imageStyleEn,
    imageStyleFr,
    imageStylePor,
    imageStyleDu,
    imageStyleGr,
    imageStyleIt,
    imageStyleSp,
    emptyStyle,
} from './FiverrAdLbll.ve.css';

const styleMap = {
    'en-US': imageStyleEn,
    'fr-FR': imageStyleFr,
    'de-DE': imageStyleGr,
    es: imageStyleSp,
    'pt-BR': imageStylePor,
    'it-IT': imageStyleIt,
    'nl-NL': imageStyleDu,
};

const sizeByLocale = {
    'en-US': { width: '44px', height: '21px' },
    'fr-FR': { width: '92px', height: '21px' },
    'de-DE': { width: '86px', height: '21px' },
    es: { width: '82px', height: '21px' },
    'pt-BR': { width: '88px', height: '21px' },
    'it-IT': { width: '85px', height: '21px' },
    'nl-NL': { width: '112px', height: '21px' },
};

interface FiverrAdLblProps {
    isPromoted: boolean;
    faUrl: string;
}
export const FiverrAdLbl = ({ isPromoted, faUrl }: FiverrAdLblProps) => {
    const { locale } = getContext();
    const style = isPromoted ? styleMap[locale] || imageStyleEn : emptyStyle;
    return faUrl ? (
        <Image
            alt=""
            src={faUrl}
            width="auto"
            maxWidth={sizeByLocale[locale].width}
            maxHeight={sizeByLocale[locale].height}
            flexShrink={0}
        />
    ) : (
        <Container as="span" className={style} />
    );
};
